import { render, staticRenderFns } from "./TemplateView.vue?vue&type=template&id=255c295d&scoped=true&"
import script from "./TemplateView.vue?vue&type=script&lang=js&"
export * from "./TemplateView.vue?vue&type=script&lang=js&"
import style0 from "./TemplateView.vue?vue&type=style&index=0&id=255c295d&lang=scss&"
import style1 from "./TemplateView.vue?vue&type=style&index=1&id=255c295d&lang=scss&scoped=true&"
import style2 from "./TemplateView.vue?vue&type=style&index=2&id=255c295d&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255c295d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('255c295d')) {
      api.createRecord('255c295d', component.options)
    } else {
      api.reload('255c295d', component.options)
    }
    module.hot.accept("./TemplateView.vue?vue&type=template&id=255c295d&scoped=true&", function () {
      api.rerender('255c295d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/services/requests/edit/TemplateView.vue"
export default component.exports